module.exports = __webpack_public_path__ + "static/media/img31.ead6038a.jpg";